<template>
    <div class="companyDetail">
        <div class="name">{{datas.name}}</div>
        <div class="time">{{datas.times | times}}</div>
        <div class="img">
            <img :src="datas.imgUrl" alt="">
        </div>
        <div class="introduce">
            <p class="title">企业介绍</p>
            <p class="content">{{datas.introduce}}</p>
        </div>
        <div class="business">
            <p class="title">资源清单</p>
            <p class="content">{{datas.business}}</p>
        </div>
        <div class="server">
            <p class="title">服务清单</p>
            <p class="content">{{datas.server}}</p>
        </div>
        <div class="demand">
            <p class="title">需求清单</p>
            <p class="content">{{datas.demand}}</p>
        </div>
        <div class="linkman">
            <p class="title">联系人</p>
            <p class="content">{{datas.linkman}}</p>
        </div>
        <div class="phone">
            <p class="title">联系电话</p>
            <p class="content">{{datas.phone}}</p>
        </div>
        <div class="adress">
            <p class="title">联系地址</p>
            <p class="content">{{datas.adress}}</p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            datas:[]
        }
    },
    mounted:function(){
      
    },
}
</script>

<style lang="scss" scoped>
    .companyDetail{
        .content{
            color: #999999;
            line-height: 1.5;
        }
        .title{
            font-weight: bold;
            line-height: 2;
        }
        .img{
            img{
                width: 100%;
            }
            margin: .2rem auto;
        }
        .time{
            color: #999999;
            line-height: 1.5;
        }
        .name{
            font-size: .38rem;
            font-weight: bold;
            line-height: 2;
        }
        div{
            width: 94%;
            margin: 0 auto;
        }
        padding-top: 1rem;
        font-size: .3rem;
        background: #fff;
        min-height: 100vh;
    }
</style>